var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createInputAmountPayloadLegacy = function (amountSelection) {
    if (amountSelection.action === 'full_switch')
        return { value: 100, unit: '%' };
    if (amountSelection.allocation.type === 'remainder')
        return { value: 100, unit: '%' };
    if (amountSelection.allocation.type === 'amount')
        return { value: amountSelection.allocation.value, unit: '$' };
    // explicitly call out last allocation type, "percentage", for clarity
    if (amountSelection.allocation.type === 'percentage')
        return { value: amountSelection.allocation.value, unit: '%' };
    // should never get here
    return null;
};
export var createInputAllocationPayload = function (amountSelection
// account?: AllocationTarget
) {
    var payload = __assign({}, amountSelection);
    /*
    TODO: implement with multiple allocations
    if (account) {
      payload = {
        ...payload,
        maskedAccountNumber: maskAccountNumber(account.accountNumber),
        routingNumber: account.routingNumber,
        accountType: account.type,
        accountName: account.name,
      };
    }
    */
    return payload;
};
/**
 * Since opts' account id is not yet updated via the React state machine on "success",
 * we need to specifically get account id from `linkApiResponse`. Use this method to
 * get the account id from the `linkApiResponse`, not `opts`, which has not yet been
 * updated.
 *
 * @param {LinkApiResponse} linkApiResponse
 * @returns {string} accountId
 */
export var getAccountIdFromLinkApiResponse = function (linkApiResponse) {
    return linkApiResponse.responseType === 'success' ? linkApiResponse.accountId : null;
};
/**
 * Get LinkError from linkApiResponse if error exists in response.
 * Return null if error does not exist in response.
 *
 * @param {LinkApiResponse} linkApiResponse
 * @returns {LinkError | null}
 */
export var getErrorFromLinkApiResponse = function (linkApiResponse) {
    return linkApiResponse.responseType === 'error' ||
        linkApiResponse.responseType === 'pending_retry' ||
        linkApiResponse.responseType === 'next_with_error'
        ? {
            type: linkApiResponse.error.type,
            code: linkApiResponse.error.code,
            message: linkApiResponse.error.message,
            pendingRetry: linkApiResponse.responseType === 'pending_retry',
        }
        : null;
};
export var checkLinkApiRequestParamsLengthAndContainsKeys = function (linkApiRequestParams, keys, length) {
    if (linkApiRequestParams.body && 'payload' in linkApiRequestParams.body) {
        var payload_1 = linkApiRequestParams.body.payload;
        return (payload_1 &&
            Object.keys(payload_1).length === length &&
            keys.every(function (key) { return key in payload_1; }));
    }
    return false;
};
